import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageModule } from '@nano/common/image';

import { AsideComponent } from './aside.component';
import { L10nTranslationModule } from 'angular-l10n';
import { NzDividerModule } from 'ng-zorro-antd/divider';

@NgModule({
  imports: [CommonModule, ImageModule, L10nTranslationModule, NzDividerModule],
  declarations: [AsideComponent],
  exports: [AsideComponent]
})
export class AsideModule {}
